/**
 * Award routes (FSD 4.2.4, P45 PS6-U69).
 *
 * Literal `path:` strings (R3). INT spreads `AWARD_ROUTES` into `PROCUREMENT_ROUTES` and adds the
 * nav item `proc-awards` ("Awards", section s-4.2.4). Each permission is the one the screen's main
 * read declares on the server (`GET /awards` and `GET /awards/:id` are `procurement.rfq.read`).
 */

import type { RouteRecordRaw } from 'vue-router'

import { AWARD_PERMISSIONS } from '@/modules/procurement/rfq/award/api'

export const AWARD_ROUTES: RouteRecordRaw[] = [
  {
    path: '/procurement/awards',
    name: 'procurement-awards',
    component: () => import('@/modules/procurement/rfq/award/AwardsListView.vue'),
    meta: {
      titleKey: 'procurement.u69.routeTitles.awards',
      permission: AWARD_PERMISSIONS.rfqRead,
    },
  },
  {
    path: '/procurement/awards/:id(\\d+)',
    name: 'procurement-award',
    component: () => import('@/modules/procurement/rfq/award/AwardView.vue'),
    meta: {
      titleKey: 'procurement.u69.routeTitles.award',
      permission: AWARD_PERMISSIONS.rfqRead,
    },
  },
]

/** The same set as strings, for links inside the module. */
export const AWARD_PATHS = {
  awards: '/procurement/awards',
  award: (id: number) => `/procurement/awards/${id}`,
} as const
